import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { EmtTheme } from "../types";

export type EmtProgressBarProps = {
  /**
   * value of advancement
   */
  value?: number;
  nonce?: string;
  /**
   * color of the progress bar
   */
  color?: "primary" | "secondary" | "purple";
};

const TotalSearchProgressBar = styled(Box)(
  ({ theme }: { theme?: EmtTheme }) => ({
    width: "220px",
    height: "4px",
    borderRadius: "2px",
    background: theme?.palette.greyGradient[100],
  })
);

const TotalSearchInnerProgressBar = styled(Box, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color: keyof EmtTheme["palette"] }>(({ theme, color }) => ({
  height: "4px",
  borderRadius: "2px",
  // @ts-ignore
  background: theme.palette[color].main || theme.palette.primary.main,
}));

export function EmtProgressBar(props: EmtProgressBarProps) {
  const { value = 1, color = "primary" } = props;
  return (
    <TotalSearchProgressBar>
      <TotalSearchInnerProgressBar sx={{ width: `${value}%` }} color={color} />
    </TotalSearchProgressBar>
  );
}
